import helpers from "../modules/helpers";

const singlePost = {
  init: function () {
    singlePost.share();
    singlePost.events();
  },
  events: function () {
    var content = $(".newsitem__content__inner");
    content.toggleClass(
      "moreable",
      $(".entry-content").height() > content.height()
    );
    $(window).resize(function () {
      content
        .not(".mored")
        .toggleClass(
          "moreable",
          $(".entry-content").height() > content.height()
        );
    });
    $(".newsitem__more .btn").click(function () {
      $(".newsitem__more").slideUp(200);
      content.addClass("mored").animate(
        {
          maxHeight: $(".entry-content").height(),
        },
        500,
        function () {
          content.css({
            maxHeight: "99999px",
          });
        }
      );
    });
  },
  share: function () {
    if ($(".soc-share").length) {
      $("body").on("click", ".soc-share", function (e) {
        e.preventDefault();

        var platform = $(this).attr("data-platform");
        var data = $(this).attr("data-content");

        helpers.share(platform, data);
      });
    }
  },
};

export default singlePost;
